/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MovableItemList } from '../../models/movable-item-list';

export interface WarehouseControllerGetMovable$Params {
  idOrder: number;
  query?: string;
  name?: string;
  code_internal?: string;
  code_supplier?: string;
  code_ean?: string;
  brand?: string;
  desc_short?: string;
  part_number?: string;
  cat_id?: number;
  related_order_id?: number;
  stock_type?: number;
  agreement_id?: number;
  hide_zero_stock?: boolean;
  order_by?: string;
  order_direction?: string;
}

export function warehouseControllerGetMovable(http: HttpClient, rootUrl: string, params: WarehouseControllerGetMovable$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerGetMovable.PATH, 'get');
  if (params) {
    rb.path('idOrder', params.idOrder, {});
    rb.query('query', params.query, {});
    rb.query('name', params.name, {});
    rb.query('code_internal', params.code_internal, {});
    rb.query('code_supplier', params.code_supplier, {});
    rb.query('code_ean', params.code_ean, {});
    rb.query('brand', params.brand, {});
    rb.query('desc_short', params.desc_short, {});
    rb.query('part_number', params.part_number, {});
    rb.query('cat_id', params.cat_id, {});
    rb.query('related_order_id', params.related_order_id, {});
    rb.query('stock_type', params.stock_type, {});
    rb.query('agreement_id', params.agreement_id, {});
    rb.query('hide_zero_stock', params.hide_zero_stock, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MovableItemList;
      }>;
    })
  );
}

warehouseControllerGetMovable.PATH = '/warehouse/movable-products/{idOrder}';
